/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.20.2-27-g52fb3b68-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdateCertificateCredential interface.
 */
export function instanceOfUpdateCertificateCredential(value) {
    if (!('label' in value) || value['label'] === undefined)
        return false;
    return true;
}
export function UpdateCertificateCredentialFromJSON(json) {
    return UpdateCertificateCredentialFromJSONTyped(json, false);
}
export function UpdateCertificateCredentialFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'label': json['label'],
    };
}
export function UpdateCertificateCredentialToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'label': value['label'],
    };
}
